import { InvoicePaymentStatus } from '#validation/billing/constants';
import { enumParser } from '#validation/common/parsers';
export const invoicePaymentStatusParser = enumParser(InvoicePaymentStatus);
